/* global Fw */
(function($, undefined) {
    'use strict';
    
    let utils;
    let lang = 'en';

    document.addEventListener('DOMContentLoaded', () => {
        utils = Fw.component.models().utils;
        lang = document.documentElement.lang;
        
        $('.js-form-document-submit').on('click', submitDocument);
        $('.delete-document-btn').on('click', deleteDocument);
        
        $('.table-documents .tablesorter-header').on('click', orderSort);
    });
    
    function submitDocument(e) {
        e.preventDefault();
        const form = $(e.currentTarget).closest('form');
        
        controlFieldsForm(form);
    }
    
    function deleteDocument(e) {
        e.preventDefault();
        const btn = e.currentTarget;
        const name = btn.getAttribute('data-name');
        const msg = lang === 'fr' ? 'Etes-vous sur de vouloir supprimer definitivement ce document ' + name + ' ?' :
            'Are you sure to delete the document, ' + name + ', permanently?';
        
        if (confirm(msg)) {
            document.getElementById(btn.getAttribute('data-form-id')).submit();
        }
    }
    
    function orderSort(e) {
        const h = e.currentTarget;
        
        utils.setRequestParams({
            edocSortBy: h.getAttribute('data-param'),
            edocSortOrder: $(h).hasClass('tablesorter-headerAsc') ? 'DESC' : 'ASC'
        });
    }
    
})(jQuery);
